import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PromptOptions } from './modal-prompt.service';

@Component({
    selector: 'modal-prompt',
    standalone: false,
    template: ''
})
export class ModalPromptComponent {}

@Component({
    selector: 'modal-prompt-dialog',
    standalone: false,
    template: `
    <mat-dialog-content class="modal-prompt-content">
      <h4 class="modal-prompt-title">{{ data.header }}</h4>
      <p>{{ data.body }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="modal-prompt-actions">
      <button mat-button type="button" class="modal-prompt-btn" [mat-dialog-close]="true">Ok</button>
      <button mat-button type="button" class="modal-prompt-btn" [mat-dialog-close]="false">Cancel</button>
    </mat-dialog-actions>
    `
})
export class ModalPromptDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: PromptOptions) {}
}